import { Grid, Paper } from '@material-ui/core'
import { Fragment } from 'react'
import ApartmentMediaForm from '../../../Forms/ApartmentMediaForm'
import { BeforeLoginStepProps } from '../../BeforeLoginStepper'

const MediaStep = ({
  apartment,
  currentStep,
  addMedia,
  deleteMedia,
  reorderMedia,
  confirmMedia,
  media,
  classes,
  signUpBeforeLogin,
  doStepBack,
  isMobile
}: BeforeLoginStepProps) => (
  <Fragment>
    {apartment?.information && currentStep === 11 && (
      <Grid container direction='row' justify='space-evenly'>
        <Grid item xs={12}>
          <Paper className={classes.formPaper}>
            <ApartmentMediaForm
              isStep
              addApartmentMedia={addMedia}
              deleteMedia={deleteMedia}
              reorderMedia={reorderMedia}
              confirmMedia={confirmMedia}
              currentStep={currentStep}
              files={media}
              media={media}
              beforeLogin
              signUpBeforeLogin={signUpBeforeLogin}
              doStepBack={doStepBack}
              classes={classes}
              isMobile={isMobile}
            />
          </Paper>
        </Grid>
      </Grid>
    )}
  </Fragment>
)

export default MediaStep
